// http://robinherbots.github.io/Inputmask/index.html
import 'inputmask/css/inputmask.css';
import 'inputmask/dist/jquery.inputmask.bundle';

const inputMask = function($container) {
  const container = $container || $('body');
  const $input = container.find($('input@inputMask'));
  const $inputPhone = container.find($('input@inputMaskPhone'));
  const inputLength = $input.length;
  const settings = {
    clearMaskOnLostFocus: false,
  };

  if (inputLength > 0) {
    $input.inputmask(settings);
  }

  if ($inputPhone.length > 0) {
    $inputPhone.inputmask({
      mask: '+1 (999) 999-9999',
      clearMaskOnLostFocus: false,
      autoUnmask: true,
      removeMaskOnSubmit: true,
      placeholder: 'X',
    });
  }
};

export default inputMask;
